import { render } from "./ModalComponent.vue?vue&type=template&id=7dea5b32&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=7dea5b32&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dea5b32"]])

export default __exports__